import { GradeModel, UpgradeModel } from "types";
import BISHOP_UPGRADES from "./bishop";
import DEFAULT_UPGRADES from "./defaults";
import SENECA_UPGRADES from "./seneca";

export const UPGRADES: Record<string, UpgradeModel> = {
  ...DEFAULT_UPGRADES,
  ...BISHOP_UPGRADES,
  ...SENECA_UPGRADES,
};

export const GRADES: Record<string, GradeModel> = {
  default: {
    slug: "default",
    name: "Default",
    color: "#777777",
    colorSecondary: "#777777",
    multiplier: 0,
  },
  basic: {
    slug: "basic",
    name: "Basic",
    color: "#aaaaaa",
    colorSecondary: "#aaaaaa",
    multiplier: 1,
  },
  advanced: {
    slug: "advanced",
    name: "Advanced",
    color: "#0c5ff2",
    colorSecondary: "#0c5ff2",
    multiplier: 1.2,
  },
  elite: {
    slug: "elite",
    name: "Elite",
    color: "#dc2eef",
    colorSecondary: "#dc2eef",
    multiplier: 1.5,
  },
  ultra: {
    slug: "ultra",
    name: "Ultra",
    color: "#facd05",
    colorSecondary: "#ff582d",
    multiplier: 2,
  },
  hypernova: {
    slug: "hypernova",
    name: "Hypernova",
    color: "#5dedff",
    colorSecondary: "#ff5fa8",
    multiplier: 3,
  },
};
